import './dom'
import './sidebar'
import './spa_navigation'
import './dark_mode'
import './auth'
import './caller'
import './form'
import './update_status'
import './modal'
import './select'
import './search'
import './flatpickr'
import './select2'
import './header_item'